import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CreditCardIcon } from "@heroicons/react/24/outline";
import CustomTitleAndSubTitle from "./customTitleAndSubTitle";
import CustomBuyForMeButtonOrders from "../ordersForBuyForMe/customOrderBuyButton";
import { useTranslation } from "react-i18next";
import BoxEmpty from "../boxDetials/boxEmpty";
import { fetchMyCarts } from "../../redux/reducer/cartReducer";
import CustomBannerCheckBox from "../boxDetials/customBannerCheckBox";
import {
  ExclamationCircleIcon,
  TruckIcon,
  CheckBadgeIcon,
} from "@heroicons/react/24/outline";
import LoadingSpinner from "../animation/LoadingSpinner";
import MoreDetailsPopup from "../ordersForBuyForMe/MoreDetailsPopup";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";
import InvoiceIcon from "../sharedComponents/InvoiceIcon";

const CustomOrders = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { carts, cartsLoading, cartsError } = useSelector(
    (state) => state.carts
  );
  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const [showPopup, setShowPopup] = useState(false);
  const currencySymbol = getCurrencyAndLanguageSymbol();
  const [selectedCart, setSelectedCart] = useState(null);

  // Select data from Redux store

  useEffect(() => {
    dispatch(fetchMyCarts());
  }, [dispatch]);

  // Handle different states
  if (cartsLoading) {
    return <LoadingSpinner />;
  }

  if (cartsError) {
    return <BoxEmpty title="EmptyShipping" />;
  }
  const FilterCarts =
    carts?.filter(
      (cart) =>
        cart.status === "packed" ||
        cart.status === "shipped" ||
        cart.status === "delivered"
    ) || [];

  if (!FilterCarts || FilterCarts.length === 0) {
    return <BoxEmpty title="EmptyShipping" />;
  }
  // console.log(FilterCarts)
  // console.log(selectedCart)
  return (
    <div className="w-full ">
      <div className="flex flex-col gap-5 mb-5">
        {/* Render a list of shipment details */}
        {FilterCarts.map((cart, index) => (
          <div key={index} className="bg-white border-b border-gray-200 ">
            <CustomBannerCheckBox
              orderNumber={cart?.referenceCode}
              isPaid={cart?.isConvertedToOrder}
            />
            {/* Display shipment details */}
            <div className="p-4">
              <div
                className={`flex w-full items-center justify-between mb-3 mt-1 rounded-md`}
              >
                {/* Order status */}
                <div className="flex font-bold">
                  <span className="text-xs text-gray-800 lg:text-base">
                    {t("OrderStatus")} :{" "}
                  </span>
                  <span className="flex text-xs text-gray-800 lg:text-base">
                    {cart.status === "packed" ? (
                      <span className="flex gap-1 text-black ms-1">
                        {t("NotShippedYet")}
                        <ExclamationCircleIcon className="w-4 h-4 lg:h-6 lg:w-6 text-custom-yellow" />
                      </span>
                    ) : cart.status === "shipped" ? (
                      <span className="flex gap-1 text-black ms-1">
                        {t("inWay")}
                        <TruckIcon class="h-4 w-4 lg:h-6 lg:w-6 text-green-500" />
                      </span>
                    ) : (
                      <span className="flex gap-1 text-black ms-1">
                        {t("delivered")}
                        <CheckBadgeIcon class="h-4 w-4 lg:h-6 lg:w-6 text-green-500" />
                      </span>
                    )}
                  </span>
                </div>

                {/* Shipping Company */}
                <div className="flex items-center gap-2">
                  <span className="px-4 py-1 text-xs text-black bg-gray-200 lg:text-base">
                    {cart?.shippingCompany?.companyName}
                  </span>
                </div>
              </div>

              <div className="justify-between hidden md:flex">
                <CustomTitleAndSubTitle
                  title={t("from")}
                  subTitle={
                    cart?.area === "67dfef4a100f542a2c700c04"
                      ? t("Turkey")
                      : t("Europa")
                  }
                />
                <CustomTitleAndSubTitle
                  title={t("shipping_price")}
                  subTitle={`${
                    roundToTwo(Number(cart?.totalShippingPrice)) || "0.00"
                  } `}
                  currency={currencySymbol}
                />
                <CustomTitleAndSubTitle
                  title={t("weight")}
                  subTitle={`${
                    cart?.isPacking
                      ? cart?.totalWeightAfterPacking
                      : cart?.totalWeight || "0"
                  }`}
                  currency={t("kg")}
                />
              </div>

              {/* Mobile view */}
              <div className="flex flex-col gap-4">
                <div className="flex justify-between w-full md:hidden">
                  <CustomTitleAndSubTitle
                    title={t("from")}
                    subTitle={
                      cart?.area === "67dfef4a100f542a2c700c04"
                        ? t("Turkey")
                        : t("Europa")
                    }
                  />
                  <CustomTitleAndSubTitle
                    title={t("shipping_price")}
                    subTitle={`${
                      roundToTwo(Number(cart?.totalShippingPrice)) || "0.00"
                    } `}
                    currency={currencySymbol}
                  />
                </div>
                <div className="flex justify-between w-full md:hidden">
                  <CustomTitleAndSubTitle
                    title={t("weight")}
                    subTitle={`${
                      cart?.isPacking
                        ? cart?.totalWeightAfterPacking
                        : cart?.totalWeight || "0"
                    }`}
                    currency={t("kg")}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-3 mt-5">
                {cart?.products?.map((product, index) => (
                  <img
                    key={index}
                    src={product.img}
                    alt={`product-${index}`}
                    className="object-cover w-20 h-20 rounded-md shadow-md"
                  />
                ))}
              </div>
              <div className="flex justify-between">
                <CustomBuyForMeButtonOrders
                  onClick={() => window.open(`${cart.PackagePDF}`, "_blank")}
                  children={t("invoice")}
                  icon={InvoiceIcon}
                  bgColor="bg-black"
                  textColor="text-white"
                  iconColor="text-white"
                />
                <CustomBuyForMeButtonOrders
                  onClick={() => {
                    setShowPopup(true);
                    setSelectedCart(cart);
                  }}
                  children={t("more_details")}
                  icon={CreditCardIcon}
                  textColor="text-black"
                  iconColor="text-black"
                />
              </div>
            </div>
            {showPopup && (
              <>
                <MoreDetailsPopup
                  numberOfTracking={selectedCart?.numberOfTracking}
                  cart={cart}
                  cartLink={selectedCart.linkOfTracking}
                  status={cart.status}
                  onClose={() => setShowPopup(false)}
                />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomOrders;
